// js/common/utilities/format-money.js
function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}

var currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;

document.addEventListener("DOMContentLoaded", (event) => {
  var customProductLists = document.querySelectorAll(".product-list-custom");
  if(customProductLists.length){
    customProductLists.forEach(function(customProductList){
    var productCards = customProductList.querySelectorAll("product-card");
    productCards.forEach(function(card){

      var cardVariantsSelect = card.querySelector('.addon_product_variants select');
      var cardPriceEl = card.querySelector('.sale_price_value');
      var cardComparePriceEl = card.querySelector('.compare_price_value');
      var cardVariantIdinput = card.querySelector('.first-variant-id');
      if (cardVariantsSelect != null) {
        cardVariantsSelect.addEventListener("change",function(e){
          var variantId = this.value;
          var variantPrice = this.querySelector('option[value="' + variantId + '"]').getAttribute('data-variant-price');
          var variantPriceCompare = this.querySelector('option[value="' + variantId + '"]').getAttribute('data-variant-price-compare');
          
          if (cardPriceEl != null) {
            cardPriceEl.innerHTML = formatMoney(variantPrice, currencyFormat);
          }

          if (cardPriceEl != null && variantPriceCompare > variantPrice) {
            cardComparePriceEl.innerHTML = formatMoney(variantPriceCompare, currencyFormat);
          }

          if (cardVariantIdinput != null) {
            cardVariantIdinput.value = variantId;
          }
        });
      }
      
      card.addEventListener("click",function(e){
        e.preventDefault();
        var target = e.target;
        if(target.classList.contains("addon_product_variants") || target.closest(".addon_product_variants")){
          return;
        }
        if(!target.classList.contains("product-card")){
          target = target.closest(".product-card");
        }
        if(target.hasAttribute("disabled-cursor")){
          return;
        }
 
        var dropdownDrawer = target.closest(".custom-dropdowns-drawer");
        var collectionID = dropdownDrawer.getAttribute("data-collection-id");
        var dropdown = document.querySelector(".custom-dropdown-collection-"+collectionID);
        var variantInput = dropdown.querySelector(".custom-dropdown-variant-id");
        var variantImg = dropdown.querySelector(".dropdown-product-image");
        // var variantPrice = dropdown.querySelector(".dropdown-product-price");
        var variantTitle = dropdown.querySelector(".dropdown-product-title");
        
        if(target.classList.contains("product-card-no-selection")){
          variantInput.value = "";
          variantImg.innerHTML = "";
          // variantPrice.innerHTML = "";
          variantTitle.innerHTML = variantTitle.getAttribute("data-default-title");
          dropdownDrawer.dispatchEvent(new CustomEvent("dialog:force-close", { bubbles: true, cancelable: true, composed: true }));       
        }else{
          variantImg.innerHTML = "";
          // variantPrice.innerHTML = "";
          var variantID = target.querySelector(".first-variant-id").value;
          variantInput.value = variantID;
          variantTitle.innerHTML = target.querySelector(".product-card__title").innerText;
          variantImg.appendChild(target.querySelector(".product-card__figure img").cloneNode());
          variantTitle.appendChild(target.querySelector(".product-card__info .price-list").cloneNode(true));
          dropdownDrawer.dispatchEvent(new CustomEvent("dialog:force-close", { bubbles: true, cancelable: true, composed: true }));       
        } 
        
      });
    });
  });
  }  
  
});